import React, { useState } from "react";
import { Check, X, Calendar, User, ArrowRight } from "lucide-react";
import ReusableModal from "../../../components/Modals/ReusableModal";
import { useNavigate } from "react-router-dom";
const ScheduleConfirmation = ({ details, open, handleClose: onClose }) => {
  const navigate = useNavigate();
  const [showConfirmation, setShowConfirmation] = useState(open);

  const handleClose = () => {
    setShowConfirmation(false);
    onClose();
  };

  const handleCloseAndNavigate = () => {
    navigate(
      `/home?providerId=${details.provider.id}&selectedDate=${details.visitDate}`
    );
  };

  return (
    <div>
      <ReusableModal
        open={showConfirmation}
        handleClose={handleClose}
        hideHeader
      >
        <div className="bg-white rounded-lg shadow-lg max-w-md w-full overflow-hidden">
          {/* Header */}
          <div className="bg-green-50 p-4 border-b border-green-100 flex items-start justify-between">
            <div className="flex items-center">
              <div className="bg-green-500 rounded-full p-2 mr-3">
                <Check className="w-5 h-5 text-white" />
              </div>
              <h3 className="text-lg font-medium text-green-800">
                Visit Scheduled Successfully
              </h3>
            </div>
            <button
              onClick={handleClose}
              className="text-gray-400 hover:text-gray-500"
            >
              <X className="w-5 h-5" />
            </button>
          </div>

          {/* Visit Details */}
          <div className="p-4 border-b">
            <h4 className="font-medium text-gray-700 mb-3">Visit Details</h4>
            <div className="grid grid-cols-2 gap-x-4 gap-y-2 text-sm">
              <div className="flex items-start">
                <span className="text-gray-500 mr-1">Patient:</span>
                <span className="font-medium">{details?.patient?.name}</span>
              </div>
              <div className="flex items-start">
                <span className="text-gray-500 mr-1">ID:</span>
                <span className="font-medium">{details.patient_id}</span>
              </div>
              <div className="flex items-start">
                <span className="text-gray-500 mr-1">Provider:</span>
                <span className="font-medium">{details.provider?.name}</span>
              </div>
              <div className="flex items-start">
                <span className="text-gray-500 mr-1">Specialty:</span>
                <span className="font-medium">
                  {details.provider?.speciality ?? "NA"}
                </span>
              </div>
              <div className="flex items-start">
                <span className="text-gray-500 mr-1">Date:</span>
                <span className="font-medium">{details.visitDate ?? "NA"}</span>
              </div>
              <div className="flex items-start">
                <span className="text-gray-500 mr-1">Time:</span>
                <span className="font-medium">{details.timeslot ?? "NA"}</span>
              </div>
              <div className="flex items-start">
                <span className="text-gray-500 mr-1">Type:</span>
                <span className="font-medium">
                  {details.appointmentType?.name ?? "NA"}
                </span>
              </div>
              <div className="flex items-start">
                <span className="text-gray-500 mr-1">Duration:</span>
                <span className="font-medium">
                  {details.appointmentType?.duration
                    ? `${details.appointmentType?.duration} minutes`
                    : "NA"}
                </span>
              </div>
              <div className="col-span-2 flex items-start">
                <span className="text-gray-500 mr-1">Location:</span>
                <span className="font-medium">
                  {details.location?.address ?? "NA"}
                </span>
              </div>
            </div>
          </div>

          {/* Next Actions */}
          <div className="p-4 bg-gray-50">
            <h4 className="font-medium text-gray-700 mb-3">
              What would you like to do next?
            </h4>
            <div className="grid grid-cols-1 gap-2">
              <button
                onClick={handleClose}
                className="flex justify-between items-center w-full p-3 border rounded bg-white hover:bg-blue-50 transition-colors"
              >
                <div className="flex items-center">
                  <User className="w-4 h-4 text-blue-600 mr-2" />
                  <span className="text-sm font-medium">
                    Schedule another patient
                  </span>
                </div>
                <ArrowRight className="w-4 h-4 text-gray-400" />
              </button>

              <button
                onClick={handleCloseAndNavigate}
                className="flex justify-between items-center w-full p-3 border rounded bg-white hover:bg-blue-50 transition-colors"
              >
                <div className="flex items-center">
                  <Calendar className="w-4 h-4 text-blue-600 mr-2" />
                  <span className="text-sm font-medium">
                    View provider's schedule
                  </span>
                </div>
                <ArrowRight className="w-4 h-4 text-gray-400" />
              </button>
            </div>
            <div className="mt-3 text-center">
              <button
                onClick={handleClose}
                className="text-sm text-gray-500 hover:text-gray-700"
              >
                Return to dispatch view
              </button>
            </div>
          </div>
        </div>
      </ReusableModal>
    </div>
  );
};

export default ScheduleConfirmation;
